const $ = require('jquery');

class Caretaker {
  /**
   * @param {Storage} storage
   */
  constructor(storage) {
    this.storage = storage;
    this.mementos = [];
    this.currentIndex = 0;
    this.buttonUndo = $('#buttonUndo');
    this.buttonRedo = $('#buttonRedo');
  }

  add(item) {
    // If the current index is not at the last element, overwrite the others
    if (this.currentIndex !== this.mementos.length - 1) {
      this.mementos = this.mementos.slice(0, this.currentIndex + 1);
    }

    const newLength = this.mementos.push(item);
    this.currentIndex = newLength - 1;
    this.emitIndexChanged();
    this.storage.putOption('currentOpenFile', this.mementos);
  }

  reset() {
    this.mementos = [];
    this.storage.deleteOption('currentOpenFile');
    this.currentIndex = 0;
    this.emitIndexChanged();
  }

  getPrevious() {
    if (this.currentIndex === 0) return null;

    this.currentIndex -= 1;
    this.emitIndexChanged();
    return this.mementos[this.currentIndex];
  }

  getNext() {
    if (this.currentIndex >= this.mementos.length) return null;
    this.currentIndex += 1;
    this.emitIndexChanged();
    return this.mementos[this.currentIndex];
  }

  emitIndexChanged() {
    if (this.currentIndex === 0) {
      this.buttonUndo.addClass('inactive');
    }

    if (this.currentIndex > 0) {
      this.buttonUndo.removeClass('inactive');
    }

    if (this.currentIndex === 0 && this.mementos.length > 1) {
      this.buttonRedo.removeClass('inactive');
    }

    if (this.currentIndex > 0 && this.currentIndex === this.mementos.length - 1) {
      this.buttonRedo.addClass('inactive');
    }

    if (this.currentIndex > 0 && this.currentIndex < this.mementos - 1) {
      this.buttonRedo.removeClass('inactive');
    }
  }

  restore(mementos) {
    this.mementos = mementos;
    this.currentIndex = this.mementos.length - 1;
    this.emitIndexChanged();
  }
}

module.exports = Caretaker;
